module.exports = __webpack_public_path__ + "img/icon1.3660532a.svg";